import { OnSaleEventTableColumnId } from 'src/navigations/Routes/OnSaleDiscovery/OnSaleDiscoveryView.types';
import { Feature } from 'src/WebApiController';

import { ColumnPersonalizationFlags } from '../columnUtils.types';
import { EventsTableColumnId } from './eventsColumnUtils.types';

export const EVENTS_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  EventsTableColumnId,
  Partial<ColumnPersonalizationFlags>
> = {
  [EventsTableColumnId.Checkbox]: { isConfigurable: false },
  [EventsTableColumnId.ATP]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.Action]: { isConfigurable: false, isRequired: true },
  [EventsTableColumnId.ActualSTR]: { isNumeric: true, isPercent: true },
  [EventsTableColumnId.Date]: { isDateTime: true },
  [EventsTableColumnId.Event]: { isHiddenByDefault: false },
  [EventsTableColumnId.Venue]: { isHiddenByDefault: false },
  [EventsTableColumnId.Location]: {},
  [EventsTableColumnId.LiftPercentage]: { isNumeric: true, isPercent: true },
  [EventsTableColumnId.ListedAtp]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.ListedQty]: { isNumeric: true, isInteger: true },
  [EventsTableColumnId.Profit]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.Revenue]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.SoldCost]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.SoldQty]: { isNumeric: true, isInteger: true },
  [EventsTableColumnId.TotalQty]: { isNumeric: true, isInteger: true },
  [EventsTableColumnId.UnsoldQty]: { isNumeric: true, isInteger: true },
  [EventsTableColumnId.UnsoldProceeds]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.UnsoldCost]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.TotalCost]: { isNumeric: true, isCurrency: true },
  [EventsTableColumnId.LastPriceUpdatedDate]: {
    isHiddenByDefault: true,
    isDateTime: true,
  },
};

export const ON_SALE_EVENTS_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  OnSaleEventTableColumnId,
  Partial<ColumnPersonalizationFlags>
> = {
  [OnSaleEventTableColumnId.Checkbox]: { isConfigurable: false },
  [OnSaleEventTableColumnId.Event]: {
    isHiddenByDefault: false,
    isConfigurable: false,
    isRequired: true,
  },
  [OnSaleEventTableColumnId.InferredPrimary]: {
    requiredFeatures: [Feature.EventDiscoveryCapacityAndPrimary],
    isHiddenByDefault: false,
    isConfigurable: false,
    isRequired: true,
  },
  [OnSaleEventTableColumnId.Venue]: {
    isHiddenByDefault: false,
    isConfigurable: false,
    isRequired: true,
  },
  [OnSaleEventTableColumnId.Capacity]: {
    requiredFeatures: [Feature.EventDiscoveryCapacityAndPrimary],
    isHiddenByDefault: false,
    isConfigurable: false,
    isRequired: true,
  },
  [OnSaleEventTableColumnId.Location]: {
    isConfigurable: false,
    isRequired: true,
  },
  [OnSaleEventTableColumnId.OnSaleDate]: {
    isDateTime: true,
    isConfigurable: true,
    isRequired: true,
  },
  [OnSaleEventTableColumnId.RawPreSaleDate]: {
    isDateTime: true,
    isConfigurable: true,
    isHiddenByDefault: true,
  },
  [OnSaleEventTableColumnId.Date]: {
    isDateTime: true,
    isConfigurable: true,
    isRequired: true,
  },
  [OnSaleEventTableColumnId.ListingCount]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
  },
  [OnSaleEventTableColumnId.TicketCount]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
  },
  [OnSaleEventTableColumnId.RecentVisits]: {
    isInteger: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isConfigurable: true,
  },
  [OnSaleEventTableColumnId.VisitsLastHour]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.VisitsLastDay]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.VisitsLast7Days]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.VisitsLast3Days]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.TransactionsLastHour]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.TransactionsLastDay]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.TransactionsLast7Days]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.TransactionsLast3Days]: {
    isNumeric: true,
    isInteger: true,
    isConfigurable: true,
    requiredFeatures: [Feature.HideEventDiscoveryDemandData],
    isReverseFeatureCheck: true,
  },
  [OnSaleEventTableColumnId.UnitNetProceedsMin]: {
    isNumeric: true,
    isCurrency: true,
    isConfigurable: true,
  },
  [OnSaleEventTableColumnId.UnitNetProceedsP25]: {
    isNumeric: true,
    isCurrency: true,
    isConfigurable: true,
  },
  [OnSaleEventTableColumnId.UnitNetProceedsP50]: {
    isNumeric: true,
    isCurrency: true,
    isConfigurable: true,
  },
  [OnSaleEventTableColumnId.Action]: {
    isConfigurable: false,
    isRequired: true,
  },
};
